import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { wsUpdate } from 'services/WService';

function LiquidateDocumentModal(props) {
  const { showNotify, setOpen } = props;
  const { document, liqStatus } = props.model;
  const { confirmChangeStateLiquid } = props;
  // const document = props.model;

  const entity = useMemo(() => {
    if (document !== undefined) {
      return `prog/sheet-document/${document.id}/liquidate`;
    }
    return '';
  }, [document]);

  async function onSubmit(data){
    await confirmChangeStateLiquid(document, liqStatus, data.responsible);
  }

  return (
    <Modal
      title={`${liqStatus?.id === 1 ? 'Anulación' : 'Parcial'} documento ${
        document?.document_sunat
      }`}
      model={document || { open: false }}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      entity={entity}
      saveButtonLabel="Confirmar"
      closeButtonLabel="Cancelar"
      onSubmit={onSubmit}
    >
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Responsable</InputLabel>
        <Select defaultValue="N" name="responsible">
          <MenuItem value="N">Normal</MenuItem>
          <MenuItem value="V">Vendedor</MenuItem>
        </Select>
      </FormControl>
    </Modal>
  );
}

export default LiquidateDocumentModal;
